import { z } from 'zod';
export const receivableStatusSchema = z.enum([
    'open',
    'partially_paid',
    'paid',
    'credit',
    'cancelled',
]);
export const receivableSchema = z.object({
    id: z.string().uuid(),
    externalSource: z.string().min(1),
    externalId: z.string().min(1),
    serviceDate: z.string().date().nullable(),
    description: z.string().min(1),
    originalAmountMinor: z.number().int(),
    currentAmountMinor: z.number().int(),
    allocatedAmountMinor: z.number().int().nonnegative(),
    outstandingAmountMinor: z.number().int(),
    currency: z.literal('PLN'),
    status: receivableStatusSchema,
    version: z.number().int().positive(),
    createdAt: z.string().datetime({ offset: true }),
});
export const paymentSchema = z.object({
    id: z.string().uuid(),
    amountMinor: z.number().int().positive(),
    allocatedAmountMinor: z.number().int().nonnegative(),
    unallocatedAmountMinor: z.number().int().nonnegative(),
    currency: z.literal('PLN'),
    method: z.enum(['cash', 'bank_transfer', 'card', 'other']),
    reference: z.string().nullable(),
    occurredAt: z.string().datetime({ offset: true }),
    createdAt: z.string().datetime({ offset: true }),
});
export const receivablesAccountSchema = z.object({
    accountId: z.string().uuid(),
    institutionId: z.string().uuid(),
    consumerId: z.string().uuid(),
    currency: z.literal('PLN'),
    chargesMinor: z.number().int(),
    paidMinor: z.number().int().nonnegative(),
    allocatedMinor: z.number().int().nonnegative(),
    balanceMinor: z.number().int(),
    creditMinor: z.number().int().nonnegative(),
    generatedAt: z.string().datetime({ offset: true }),
    receivables: z.array(receivableSchema),
    payments: z.array(paymentSchema),
});
export const postPaymentSchema = z.object({
    consumerId: z.string().uuid(),
    amountMinor: z.number().int().positive(),
    currency: z.literal('PLN').default('PLN'),
    method: z.enum(['cash', 'bank_transfer', 'card', 'other']),
    reference: z.string().trim().max(200).nullable().default(null),
    occurredAt: z.string().datetime({ offset: true }),
    autoAllocate: z.boolean().default(true),
});
export const allocatePaymentSchema = z.object({
    receivableId: z.string().uuid(),
    amountMinor: z.number().int().positive(),
});
export const correctReceivableSchema = z.object({
    amountMinor: z
        .number()
        .int()
        .refine((value) => value !== 0),
    reason: z.string().trim().min(3).max(500),
});
export const canteenBillingEventSchema = z.object({
    id: z.string().uuid(),
    institutionId: z.string().uuid(),
    eventType: z.enum([
        'canteen.reservation.confirmed.v1',
        'canteen.reservation.adjusted.v1',
    ]),
    aggregateId: z.string().uuid(),
    aggregateVersion: z.number().int().positive(),
    occurredAt: z.string().datetime({ offset: true }),
    payload: z.record(z.string(), z.unknown()),
});
